module.exports = __webpack_public_path__ + "img/memphis-03.1f4488f7.png";